import { salesOverviewReportSchema } from './chunk-CTZXUPKZ.mjs';
import * as yup from 'yup';

var creditBalanceReportSchema = salesOverviewReportSchema.concat(
  yup.object().shape({})
);

export { creditBalanceReportSchema };
